import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Card, { CardMedia } from 'material-ui/Card';
import Grid from 'material-ui/Grid';
// import Button from 'material-ui/Button';
import RadioCheckedIcon from 'material-ui-icons/RadioButtonChecked';
import BookTileFooter from './BookTileFooter';
import noCoverImgSrc from '../../assets/images/components/no_book_cover.png';
import './BookTile.css';

//TODO: Re-tesing the disable scroll function when move dialog open in moblie

import Dialog from 'material-ui/Dialog';
import Slide from 'material-ui/transitions/Slide';
import DialogBookTile from './DialogBookTile';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class BookTile extends Component {
    static propTypes = {
        book: PropTypes.object.isRequired,
        isInWatchList: PropTypes.bool.isRequired,
        isInReadList: PropTypes.bool,
        addToWatchList: PropTypes.func,
        removeFromWatchList: PropTypes.func,
        addToReadList: PropTypes.func,
        removeFromReadList: PropTypes.func
    };

    state = {
        isDialogOpen: false
    };

    clickHandler = (type) => {
        const {
            book,
            isInWatchList,
            isInReadList,
            removeFromWatchList,
            addToWatchList,
            addToReadList,
            removeFromReadList
        } = this.props;
        switch(type) {
            case 'bookMark':
                isInWatchList ? removeFromWatchList(book) : addToWatchList(book);
                break;
            case 'readMark':
                isInReadList ? removeFromReadList(book) : addToReadList(book);
                break;
            default:
                break;
        }
    };

    dialogCloseHandler = () => {
        this.setState({ isDialogOpen: false });
        document.getElementById('book-dialog').focus()
    };

    renderDialog = () => {
        return  <Dialog
                    id="book_modal"
                    disableBackdropClick
                    maxWidth="md"
                    open={this.state.isDialogOpen}
                    onClose={this.dialogCloseHandler}
                    transition={Transition} >
                    <div id="book-dialog"  aria-label="Book detail pop-up dialog" className="searchResult__dialog">
                        {this.renderDialogBookTile()}
                    </div>
                </Dialog>
    };

    dialogOpenHandler = () => {
        this.setState({
            isDialogOpen: true,
        })
    };

    renderDialogBookTile = () => {
        const {
            book,
            isInWatchList,
            isInReadList,
            addToWatchList,
            removeFromWatchList,
            addToReadList,
            removeFromReadList
        } = this.props;

        return  <DialogBookTile
                    closeDialogHandler={this.dialogCloseHandler}
                    book={book}
                    isInWatchList={isInWatchList}
                    isInReadList={isInReadList}
                    addToWatchList={addToWatchList}
                    removeFromWatchList={removeFromWatchList}
                    addToReadList={addToReadList}
                    removeFromReadList={removeFromReadList}
                />
    }

    render () {
        const {
            isHighGradeBook,
            imageSrc,
            title,
            author,
            grade
        } = this.props.book;
        return (
            <Grid item
                  md={4}
                  xs={12}
                  sm={6}>
                {this.renderDialog()}
                <Card className="bookTile__card">
                    <div className="bookTile__card--left">
                        <CardMedia
                            onClick={() => this.dialogOpenHandler()}
                            className="bookTile__card--image"
                            image={imageSrc? imageSrc : noCoverImgSrc}
                            title={`${title} cover`}
                        />
                    </div>
                    <div className="bookTile__card--right">
                        <button
                            onClick={() => this.dialogOpenHandler()}
                            className="bookTile__card--right--content">
                            <div className="card--right--bookname">
                                <p>
                                    <span className="bookname--text">
                                        {isHighGradeBook === 'Y'? <span><RadioCheckedIcon></RadioCheckedIcon></span> : isHighGradeBook==='N'? '': isHighGradeBook ? <span><RadioCheckedIcon></RadioCheckedIcon></span> : ''}
                                        <span><span className="sr-only"> Title:</span>{title}</span>
                                    </span>
                                </p>
                                <p className="card--right--author"><span className="sr-only">. Author:</span>{author}</p>
                            </div>
                            <p className="card--right--content--gradeInfo">
                                <span><span className="sr-only">. Challenge Level:</span>{grade}</span>
                            </p>
                        </button>
                        <BookTileFooter
                            clickHandler={this.clickHandler}
                            isInWatchList={this.props.isInWatchList}
                            isInReadList={this.props.isInReadList}
                        />
                    </div>
                </Card>
            </Grid>
        );
    }
}

export default BookTile;
